import { ButtonBase, resolveTextColor } from '../button-base';
import { WithTheme, bem, cx } from '@mint/core';
import { ButtonLabel } from '../button-label';
import { IconButtonProps } from './icon-button-props';
import { InkContainer } from '../ink-container';
import React from 'react';
import styled from 'styled-components';
import { useFocus } from '../shared';

const ROOT_CLASS_NAME = 'icon-button';

export const IconButtonComponent = React.forwardRef<any, IconButtonProps>(
  (props, ref): React.ReactElement => {
    const { children, className, size, ...rest } = props;

    const classes = bem(ROOT_CLASS_NAME);
    const [focused, bindFocus] = useFocus(props);

    const componentProps = {
      className: cx(classes.className, focused && classes.focused(), className),
      ref,
      inkOptions: { center: true },
      ...rest,
      ...bindFocus,
    };

    return <ButtonBase {...componentProps}>{children}</ButtonBase>;
  },
);

IconButtonComponent.displayName = 'IconButton';

const size = (props: WithTheme<IconButtonProps>): string => {
  switch (props.size) {
    case 'xxs':
      return '1rem';
    case 'xs':
      return '1.25rem';
    case 'sm':
      return '1.5rem';
    case 'lg':
      return '2.5rem';
    case 'md':
    default:
      return '2rem';
  }
};

const fontSize = (props: WithTheme<IconButtonProps>): string => {
  switch (props.size) {
    case 'xxs':
      return '0.5rem';
    case 'xs':
      return '0.7rem';
    case 'lg':
      return '1.25rem';
    case 'sm':
    case 'md':
    default:
      return '1rem';
  }
};

export const IconButton = styled(IconButtonComponent)`
  font-size: ${fontSize};
  height: ${size};
  line-height: ${size};
  width: ${size};
  padding: 0;

  &,
  ${InkContainer} {
    border-radius: ${size};
  }
`;
